function n(r) {
  return typeof r != "string" || !r.includes("var(--mantine-scale)") ? r : r.match(/^calc\((.*?)\)$/)?.[1].split("*")[0].trim();
}
function t(r) {
  const e = n(r);
  return typeof e == "number" ? e : typeof e == "string" ? e.includes("calc") || e.includes("var") ? e : e.includes("px") ? Number(e.replace("px", "")) : e.includes("rem") ? Number(e.replace("rem", "")) * 16 : e.includes("em") ? Number(e.replace("em", "")) * 16 : Number(e) : NaN;
}
export {
  t as p
};
